var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14,5.14285714 C14,2.30253557 10.8659922,0 7,0 C3.13400644,0 0,2.30253557 0,5.14285714 C0,7.98317871 3.13400644,10.2857143 7,10.2857143 L7.87499923,10.2857143 C8.74999914,11.1428571 10.5,12 12.2499988,12 C11.8124988,11.5714286 11.3749989,10.2857143 11.3749989,9.16071429 L11.3749989,9.16071429 C13.0354365,8.18400233 14.0013282,6.70559645 14,5.14285714"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon_chat.cf894544756866d5aa127faeeb85119b.svg";
export { ForwardRef as ReactComponent };